import KoFiImage from '../../img/kofi-colour.png';
import '../../css/CallToDonate.css';

const CallToDonate = () => 
  <div className={"CallToDonate"} onClick={() => window.open("https://ko-fi.com/fullmeter", '_blank')}>
    <img src={KoFiImage} alt="KoFi" />
    <p>Did I save you some time?<br/><u>Buy me a coffee!</u></p>
  </div>

export default CallToDonate;